import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({
      isLoadingStore: false,
      sidebarOpenStore: true,
      accessTokenStore: null,
      userInfoStore: null,
      storeSetLoading: (loading) => {
        set({ isLoadingStore: loading });
      },
      storeSetSidebarOpening: (open) => {
        set({ sidebarOpenStore: open });
      },
      storeSetUserInfo: (userInfo) => {
        set({ userInfoStore: userInfo });
      },
      storeLogin: (token, userInfo) => {
        set({
          accessTokenStore: token,
          userInfoStore: userInfo,
        });
      },
      storeLogout: () => {
        set({ accessTokenStore: null, userInfoStore: null });
      },
    }),
    {
      name: "user",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useStore;
